export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20flowing%20coral%20and%20terracotta%20shapes%20soft%20elegant%20curves%20minimal%20design%20with%20gentle%20texture%20subtle%20light%20playing%20across%20the%20surface&width=1600&height=600&seq=cta-bg-91&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      <div className="relative z-10 mx-auto text-center" style={{ maxWidth: 640 }}>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          立即加入91网，开启高效资源之旅
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8">
          免费注册即可畅享海量资源，升级VIP会员获得更多专属权益
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
          >
            免费注册
          </a>
          <a
            href="#"
            className="px-8 py-3.5 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-all cursor-pointer"
          >
            了解会员权益
          </a>
        </div>
      </div>
    </section>
  );
}